import React, { useEffect, useRef } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useTranslation } from 'react-i18next';
import { BasicInput, Typography } from '@dev/ee-components';
import { ModifyForm, getFormCreatorStore } from '@/store/formCreator/actions';
import { FORM_NAME_MAX_LENGTH } from '../../constants';
import { Step1EditContentWrapper } from './styles';

export const Step1EditContent = (): JSX.Element => {
    const inputRef = useRef<HTMLInputElement>();
    const { t } = useTranslation();
    const dispatch = useDispatch();
    const { formObject, formPayload, errors } = useSelector(getFormCreatorStore);

    const onNameChange = (e): void => {
        dispatch(ModifyForm({ Name: e.target.value?.slice(0,FORM_NAME_MAX_LENGTH) }));
    };

    const value = formPayload?.Name ?? formObject?.Name ?? '';

    useEffect((): void => {
        if (formObject?.Name) {
            return;
        }
        inputRef.current?.focus();
    },[]);

    return (
        <Step1EditContentWrapper>
            <Typography variant="body1">{t('formname_description')}</Typography>
            <div>
                <BasicInput
                    inputRef={inputRef}
                    id="formcreator-step1-name"
                    label={t('formname')}
                    type="input"
                    value={value}
                    fullWidth
                    onChange={onNameChange}
                    autoComplete="off"
                    error={!!errors?.DuplicatedName}
                    errorMessage={t('formnamealreadyinuse')}
                />
            </div>
        </Step1EditContentWrapper>
    );
};
